module.exports = __webpack_public_path__ + "img/Size=32, Style=regular.c7a70945.svg";